import React from "react";

import { TYPE_TO_ICON_CONFIG } from "@app/analytics/Home/constants";
import type { FeedItem } from "@app/analytics/Home/types";
import ROUTES from "@app/common/routes";

import Stack, { Column, Row } from "@rui/Stack";

import {
  Line,
  MainContentContainer,
  OuterItemContainer,
  Wrapper,
} from "./styles";
import HomeFeedItemHeader from "../HomeFeedItemHeader";

type BaseHomeFeedItemLayoutProps = FeedItem & {
  alert?: React.ReactNode;
  children?: React.ReactNode;
  onClick: (id: string) => void;
};

const BaseHomeFeedItemLayout = ({
  alert = null,
  children,
  onClick,
  ...item
}: BaseHomeFeedItemLayoutProps) => {
  const { color } = TYPE_TO_ICON_CONFIG[item.type];

  // TODO (ENG-9591): Align differently based on feed item ownership
  const align = "left";

  const handleClick = () => {
    // TODO (ENG-9588): use the item's actual id instead of entity id when we have ids (i.e., when BE is hooked up)
    onClick(item.entityId);
  };

  return (
    <Wrapper>
      <OuterItemContainer onClick={handleClick}>
        {alert}
        <MainContentContainer spacing={1}>
          <HomeFeedItemHeader
            align={align}
            link={{
              label: item.session.title,
              href: ROUTES.meetingReportById(item.session.id),
            }}
            title={item.title}
            timestamp={item.timestamp}
            type={item.type}
          />
          <Row
            spacing={1}
            flexDirection={align === "left" ? "row" : "row-reverse"}
          >
            {children && <Line color={color} />}
            <Column width="100%" spacing={1}>
              {children && <Stack>{children}</Stack>}
            </Column>
          </Row>
        </MainContentContainer>
      </OuterItemContainer>
    </Wrapper>
  );
};

export default BaseHomeFeedItemLayout;
